<template>
  <div class="row plain-element">
    <div v-if="!isLoggedIn()" class="dashboard-cards">
      <NoPermissionComponent/>
    </div>
    <div v-if="getUsername()" class="dashboard" v-cloak>
      <div class="row row-cards">
        <div class="row text-start row-back">
          <a href="/">
            <i class="fas fa-chevron-left"></i> Back To Homepage
          </a>
        </div>

        <div class="card card-description">
        <div class="row-plans-tabs plain-element text-center">
          <div class=" col col-4 col-sm-4 col-md-3 col-lg-2 plain-element text-start">
            <div class="btn-plans-tab">
              <div class="tab-plans-active" @click="goToPowerBIStandardSearch">
                <span>Standard Search</span>
              </div>
            </div>
          </div>
          <div class=" col col-4 col-sm-4 col-md-3 col-lg-2 plain-element text-start">
            <div class="btn-plans-tab" @click="goToPowerBISelectSearch">
              <div>Select Search</div>
            </div>
          </div>
        </div>
        <div v-if="getPowerBIDashboards()" class="row plain-element">
            <div v-if="getSingleSite() === false" class=" col col-12 col-sm-12 col-md-8 col-lg-3 plain-element">
              <div class=" col col-12 col-sm-12 col-md-8 col-lg-11 plain-element">
                <span class="section-header ">Select Site</span>
              </div>
              <div v-for="(value, key) in getPowerBIDashboards()" class="input-field  col col-12 col-sm-7 col-form" :key="key" :value="value">
                <a @click="setSite(key)">
                  <div v-if="site_code === key" class="card menu-card" style="background-color: #00cdf8">
                    <h5><i class="fas fa-chevron-right" aria-hidden="true"></i> {{ splitString(key)[0] }} <span style="color: grey">{{ splitString(key)[1] }}</span></h5>
                  </div>
                  <div v-else class="card menu-card">
                    <h5><i class="fas fa-chevron-right" aria-hidden="true"></i> {{ splitString(key)[0] }} <span style="color: grey">{{ splitString(key)[1] }}</span></h5>
                  </div>
                </a>
              </div>
            </div>
            <div  v-if="site_code !== 'All'" class="col col-12 col-sm-12 col-md-8 col-lg-9 plain-element">
              <div class="row plain-element">
                <div class=" col col-12 col-sm-12 col-md-8 col-lg-4 plain-element">
                  <span class="section-header ">Select Dashboard</span>
                </div>
              </div>
              <div  class="row plain-element">
                <div class=" col col-12 col-sm-12 col-md-8 col-lg-4 plain-element">
                  <div  v-for="(value, key) in getPowerBIDashboards()[site_code].slice(0,12)" class="input-field  col col-12 col-sm-9 col-form" :key="key" :value="value">
                    <a @click="gotToPowerBIDashboard(value[1])">
                      <div class="card menu-card">
                        <h5><i class="fas fa-chevron-right" aria-hidden="true"></i> {{ value[0] }} </h5>
                      </div>
                    </a>
                  </div>
                </div>
                <div class=" col col-12 col-sm-12 col-md-8 col-lg-4 plain-element">
                  <div  v-for="(value, key) in getPowerBIDashboards()[site_code].slice(12,24)" class="input-field  col col-12 col-sm-9 col-form" :key="key" :value="value">
                    <a @click="gotToPowerBIDashboard(value[1])">
                      <div class="card menu-card">
                        <h5><i class="fas fa-chevron-right" aria-hidden="true"></i> {{ value[0] }} </h5>
                      </div>
                    </a>
                  </div>
                </div>
                <div class=" col col-12 col-sm-12 col-md-8 col-lg-4 plain-element">
                  <div  v-for="(value, key) in getPowerBIDashboards()[site_code].slice(24,50)" class="input-field  col col-12 col-sm-9 col-form" :key="key" :value="value">
                    <a @click="gotToPowerBIDashboard(value[1])">
                      <div class="card menu-card">
                        <h5><i class="fas fa-chevron-right" aria-hidden="true"></i> {{ value[0] }} </h5>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue";


export default {
  name: "PowerBISelectView",
  components: {
    NoPermissionComponent,

  },
  props: {
    site: { type: String, required: false },
  },
  data() {
    return {
      site_code: this.site
    }
  },

  methods: {
    ...mapGetters(["getUsername", "isLoggedIn", "getServiceSitesAndSeu", "getLoader", "getFormError","getPowerBIDashboards", "getSiteNames", "getSingleSite"]),
    ...mapActions(["performSetFormError", "fetchPowerBIDashboards"]),
    setSite(site) {
      this.site_code = site
    },
    async fetchDashboards() {
      await this.fetchPowerBIDashboards();
      if (this.getSingleSite()) {
        const keys = Object.keys(this.getPowerBIDashboards());
        if (keys.length > 0) {
          this.site_code = keys[0];
        }
      }
    },
    gotToPowerBIDashboard(id) {
      if (event.ctrlKey === true) {
        window.open(`/power-bi/powerbi/${id}`, '_blank');
      } else {
        window.open(`/power-bi/powerbi/${id}`, '_blank');
      }
    },
    goToPowerBIStandardSearch() {
      location.href=(`/powerbi-select/All`);
    },
    goToPowerBISelectSearch() {
      location.href=(`/power-bi/powerbi-dashboards`);
    },
    splitString(string) {
      const parts = string.split('[');
      const name = parts[0].trim();
      const site_code = '[' + parts[1].trim();
      return [name, site_code];
    },

  },
  created() {
    document.title = "SEU Dashboards";
    this.performSetFormError(null)
    this.fetchDashboards();
    window.scrollTo(0,0);
  },
  watch: {
    site(newSite) {
      this.site_code = newSite;
    },
  },
}


</script>
<style scoped>
.expanded {
  cursor: pointer;
}
.expanded:hover {
  text-decoration: underline;
}
</style>